module.exports = __webpack_public_path__ + "static/media/nft.6c336d63.mp4";